import React from "react";

export const MovesPageContext = React.createContext();